<template>
  <div class="grid grid-cols-8 gap-2 mb-4 border border-neutral p-2">
    <!-- First row with filled items -->
    <div
      v-if="isLoading && missionStore.mateEquipmentList.length === 0"
      class="flex justify-center items-center w-full h-full min-h-[200px] col-span-8"
    >
      <div class="loading loading-ring loading-lg"></div>
    </div>
    <template v-else>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="aspect-square relative cursor-pointer"
        @click="clickEquipment(item)"
      >
        <EquipmentIcon :equipment="item" show-lock />
        <!-- <i
          v-if="selectIds?.includes(item.id)"
          class="iconify mingcute--check-circle-fill absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-10 text-primary"
        /> -->

        <CheckCircleFillIcon
          v-if="selectIds?.includes(item.id)"
          class="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-10 text-primary"
        />
      </div>
      <!-- Empty slots for remaining rows -->
      <template
        v-if="
          missionStore.mateEquipmentList.length <
          userStore.user.equipmentInventoryCapacity
        "
      >
        <div
          v-for="i in userStore.user.equipmentInventoryCapacity -
          missionStore.mateEquipmentList.length"
          :key="`empty-${i}`"
          class="aspect-square bg-base-300 border rounded-md"
        />
      </template>
    </template>

    <EquipmentDetailModal
      v-model:show="showEquipmentModal"
      :equipment="selectedEquipment"
      :mode="mode"
      :is-select="selectIds?.includes(selectedEquipment.id)"
      @select="clickSelect"
    />
  </div>
</template>

<script setup lang="ts">
import { EquipmentType } from "@/enums/mission";
import { useGlobalUser } from "@/stores/globalUser";
import { useMission } from "@/stores/mission";

import { MateEquipment } from "@/types/entity";
import { computed, onMounted, ref } from "vue";

const props = defineProps<{
  mode: "select" | "edit";
  selectIds?: number[];
}>();

const emit = defineEmits<{
  (e: "select", equipment: MateEquipment): void;
}>();

const missionStore = useMission();
const userStore = useGlobalUser();

const list = computed(() => {
  if (props.mode === "select") {
    return missionStore.mateEquipmentList.filter(
      (item) => item.type === EquipmentType.Item
    );
  }
  return missionStore.mateEquipmentList;
});

const selectedEquipment = ref<MateEquipment>({} as MateEquipment);
const showEquipmentModal = ref(false);
const isLoading = ref(false);
const clickEquipment = (item: MateEquipment) => {
  selectedEquipment.value = item;
  showEquipmentModal.value = true;
};

const clickSelect = () => {
  showEquipmentModal.value = false;
  emit("select", selectedEquipment.value);
};

onMounted(async () => {
  try {
    isLoading.value = true;
    await missionStore.getMateEquipmentList(true);
    if (missionStore.mateEquipmentList.length > 0) {
      selectedEquipment.value = missionStore.mateEquipmentList[0];
    }
  } catch (error) {
    console.error("Failed to load equipment items:", error);
  } finally {
    isLoading.value = false;
  }
});
</script>
